import { hu } from "date-fns/locale";
import { sk } from "date-fns/locale";
import { enUS } from "date-fns/locale";
import type { Locale } from "date-fns";

/**
 * Returns the date-fns locale for the given i18n language code.
 * Used so date formatting (e.g. format(), formatDistanceToNow) follows the app language.
 */
export function getDateFnsLocale(lng: string): Locale {
  switch (lng) {
    case "sk":
      return sk;
    case "en":
      return enUS;
    case "hu":
    default:
      return hu;
  }
}
